// extracted by mini-css-extract-plugin
export default {"cursorContainer":"RemoteCursor_cursorContainer__VbGCJ","cursorIcon":"RemoteCursor_cursorIcon__xWl7N","tooltip":"RemoteCursor_tooltip__yNHlx"};